export default {
  parts: ['control', 'label'],
  baseStyle: {
    control: {
      _invalid: {
        border: 'red.500',
      },
    },
    label: {
      _invalid: {
        color: 'red.500',
      },
    },
  },
}
